<template>
  <v-layout wrap style="height: 100px">
    <v-navigation-drawer v-model="enableFilters" persistent fixed width="600">
      <v-toolbar color="white" class="elevation-0">
        <v-toolbar-title>Filtros</v-toolbar-title>
      </v-toolbar>
      <v-spacer></v-spacer>
      <v-form>
        <v-container>
          <v-layout>
            <v-flex xs12 md4>
              <v-menu
                v-model="menuStartAt"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="computedStartAtFormatted"
                    label="Data Inicial"
                    persistent-hint
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="startAt"
                  no-title
                  @input="menuStartAt = false"
                  class="no-pointer-events"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 md4>
              <v-menu
                v-model="menuEndAt"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="computedEndAtFormatted"
                    label="Data Final"
                    persistent-hint
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="endAt"
                  no-title
                  @input="menuEndAt = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
          <div>
            <v-subheader>Outros Filtros</v-subheader>
          </div>
          <v-layout>
            <status />
          </v-layout>
          <v-layout>
            <payer />
          </v-layout>
          <v-layout>
            <amount />
          </v-layout>
          <v-layout>
            <order />
          </v-layout>

          <v-btn @click="getResources">Enviar</v-btn>
          <v-btn @click="reset">Limpar</v-btn>
          <v-btn @click="desableFilters">Fechar</v-btn>
        </v-container>
      </v-form>
    </v-navigation-drawer>
  </v-layout>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/services/event-bus";

export default {
  created() {
    this.$store.dispatch("account/getAccount");
  },
  components: {
    Status: () => import("./options/Status.vue"),
    Payer: () => import("./options/Payer.vue"),
    Amount: () => import("./options/Amount.vue"),
    Order: () => import("./options/Order.vue"),
  },
  data: (vm) => ({
    startAt: null,
    endAt: null,
    startAtFormatted: vm.formatDate(new Date().toISOString().substr(0, 10), 'start'),
    endAtFormatted: vm.formatDate(new Date().toISOString().substr(0, 10), 'end'),
    menuStartAt: false,
    menuEndAt: false,
    enableFilters: false,
  }),
  computed: {
    ...mapGetters({
      filters: "bills/billsFilter",
      limit: "bills/billsLimit",
      page: "bills/billsCurrentPage",
      storeStatus: "bills/filtersStatus",
      storePayerName: "bills/filtersPayerName",
      storeOrdination: "bills/filtersOrdination",
      storeShowFilters: "bills/showFilters",
      storeAmount: "bills/filtersAmount",
      partnerLevel: "account/partner",
    }),
    showFilters: {
      get() {
        return this.storeShowFilters;
      },
      set(value) {
        this.$store.dispatch("bills/showFilters", value);
      }
    },
    status: {
      get() {
        return this.storeStatus;
      },
      set(newStatus) {
        this.$store.dispatch("bills/setStatus", newStatus);
      },
    },
    payerName: {
      get() {
        return this.storePayerName;
      },
      set(newPayerName) {
        this.$store.dispatch("bills/setPayerName", newPayerName);
      },
    },
    amount: {
      get() {
        return this.storeAmount;
      },
      set(newAmount) {
        this.$store.dispatch("bills/setAmount", newAmount);
      },
    },
    ordination: {
      get() {
        return this.storeOrdination;
      },
      set(value) {
        this.$store.dispatch("bills/setOrdination", value);
      },
    },
    computedStartAtFormatted() {
      return this.formatDate(this.startAt, 'start');
    },
    computedEndAtFormatted() {
      return this.formatDate(this.endAt, 'end');
    },
  },
  watch: {
    storeShowFilters(newValue) {
      this.enableFilters = newValue;
    },
    startAt(val) {
      this.startAtFormatted = this.formatDate(this.startAt, 'start');
      this.$store.dispatch('bills/setInitialDate', this.startAtFormatted);
    },
    endAt(val) {
      this.endAtFormatted = this.formatDate(this.endAt, 'end');
      this.$store.dispatch('bills/setFinalDate', this.endAtFormatted);
    },
  },
  methods: {
    /* eslint-disable */
    getResources() {
      const params = {
        page: this.page,
        limit: this.limit,
        filterrific: {
          with_created_at_between: {
            start_at: this.formatDate(this.startAt, 'start'),
            end_at: this.formatDate(this.endAt, 'end'),
          },
          with_status: this.status,
          with_payer_name: this.payerName,
          with_amount: this.amount,
          sorted_by: this.ordination,
        },
      };
      this.$store.dispatch("bills/loadBills", params);
      this.desableFilters();
    },
    desableFilters() {
      this.$store.dispatch("bills/showFilters", false);
      this.enableFilters = false;
    },
    reset() {
      this.$store.dispatch("bills/resetFilters", this.filters);
      this.$store.dispatch("bills/loadBills");
    },
    formatDate(date, kind) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      if (kind == 'start') { 
        return `${year}-${month}-${day} 00:00:00`;
      } else {
        return `${year}-${month}-${day} 23:59:59`;
      }
    }
  },
};
</script>